import { UsersIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <UsersIndexRouteView/>,
};